import React from "react";
import Config from "../../../config/main";
import OddConverter from "@common/helpers/oddConverter";
import {handicapBaseFormat} from "../../../helpers/filters";
import { t } from "../../../helpers/translator";
let conf = Config.main;

export default function EvevntTemplate () {
    let { homeScore, awayScore, hoursType, isDisable, boostedOdds, standartViewHomePage } = this.props;
    let event = this.props.event,
        price = OddConverter(event && event.price, this.props.oddsFormat, null, this.props.market && this.props.market.display_key), //eslint-disable-line react/prop-types
        priceChange = event && event.price_change && event.price_change.toString(),
        market = this.props.market,
        blockedEventClass = (this.props.game.is_blocked || (conf.blockedPrices && conf.blockedPrices.minPrice && conf.blockedPrices.minPrice) && ((event && event.price) >= conf.blockedPrices.minPrice && (event && event.price) <= conf.blockedPrices.maxPrice)) ? ' blockedEvent ' : '',
        blockedHorseEvent = isDisable ? ' blockedHorseEvent ' : '';
    return (
        <div className={"single-coefficient-m" + blockedHorseEvent + blockedEventClass + (this.isEventInBetslip() ? " active" : "")}
            onClick={this.props.quickBet ? this.makeQuickBet : this.toggle}
        >
            {
                this.props.name
                    ? <i className="event-text-v-b">{t(this.props.name)} {handicapBaseFormat(event.base, undefined, true, market.display_key, homeScore || market.home_score, awayScore || market.away_score, (event.type || event.type_1))}</i>
                    : null
            }
            {hoursType !== "SP" &&
                <span className={event && event.id ? event.id : ""}>
                    {
                        boostedOdds && !standartViewHomePage ? market.event && Object.keys(market.event).find((item) => boostedOdds[item]) && <i className='global-icon icon-boosted'></i>
                            : standartViewHomePage && market[0].event && Object.keys(market[0].event).find((item) => boostedOdds[item]) && <i className='global-icon icon-boosted'></i>
                    }
                    {this.props.showBase && event && (event.base || event.base === 0)
                        ? <b className="coef">
                            {market.display_key === "TOTALS" && conf.homeAwayBaseRecalculationEnabled && conf.fractionalBaseFormat &&
                                <i className="u-o-market">
                                    {event.name === "Over " ? "O" : (event.name === "Under " ? "U" : event.name)}
                                </i>}
                            {+handicapBaseFormat(event.base, undefined, true, market.display_key, homeScore || market.home_score, awayScore || market.away_score, (event.type || event.type_1)) > 0 ? handicapBaseFormat(event.base, undefined, true, market.display_key, homeScore || market.home_score, awayScore || market.away_score, (event.type || event.type_1)) : handicapBaseFormat(event.base, undefined, true, market.display_key, homeScore || market.home_score, awayScore || market.away_score, (event.type || event.type_1))}</b> : null}
                    {+price || price && hoursType !== t("SP") ? <i className={{ "-1": "top-m", "1": "bot-m " }[priceChange]}>{price}</i> : null}
                </span>
            }
        </div>
    );
}